import { render, staticRenderFns } from "./TicketPosition.vue?vue&type=template&id=6c500dd0"
import script from "./TicketPosition.vue?vue&type=script&lang=ts"
export * from "./TicketPosition.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports